import { render, staticRenderFns } from "./BrainIcon.vue?vue&type=template&id=829b4df2&"
import script from "./BrainIcon.vue?vue&type=script&lang=ts&"
export * from "./BrainIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports